import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'lovers-contador',
  templateUrl: './contador.component.html',
  styleUrls: ['./contador.component.scss'],
})
export class ContadorComponent implements OnInit {
  @Input() public valorAtual: number = 0;
  @Input() public valorMaximo: number = 99;
  @Input() public valorMinimo: number = 0;
  @Input() public quantidadeAlteracao: number = 1;
  @Input() public disabled: boolean = false;
  @Output() public onValueChanged: EventEmitter<number> =
    new EventEmitter<number>();

  public valorMinimoBlock: number = 0;
  public valorMaximoBlock: number = 0;

  constructor() {}

  ngOnInit(): void {
    this.tratarDados();
  }

  private tratarDados(): void {
    if (this.valorMinimo > this.valorAtual) {
      this.valorAtual = this.valorMinimo;
    }

    if (this.valorMaximo < this.valorAtual) {
      this.valorAtual = this.valorMaximo;
    }

    this.valorMaximoBlock = this.valorMaximo;
    this.valorMinimoBlock = this.valorMinimo;
  }

  public adicionar(): void {
    const novoValor = this.valorAtual + this.quantidadeAlteracao;
    if (novoValor > this.valorMaximo) return;
    this.onChange(novoValor);
  }

  public subtrair(): void {
    const novoValor = this.valorAtual - this.quantidadeAlteracao;
    if (novoValor < this.valorMinimo) return;
    this.onChange(novoValor);
  }

  private onChange(valor: number): void {
    this.valorAtual = valor;
    this.onValueChanged.emit(this.valorAtual);
  }

  ngOnChanges() {
    this.tratarDados();
  }
}
